import { render, staticRenderFns } from "./CreateEscalationMatrixModal.vue?vue&type=template&id=319ed352&scoped=true"
import script from "./CreateEscalationMatrixModal.vue?vue&type=script&lang=js"
export * from "./CreateEscalationMatrixModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEscalationMatrixModal.vue?vue&type=style&index=0&id=319ed352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ed352",
  null
  
)

export default component.exports